import { UserLoginResponse } from "./../../models/rest/user/userLoginResponse";
import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MenuItemWithSubDto } from "../../models/dto/menuItemWithSubDto";
declare var $: any;

interface SearchResult {
  category: string;
  menuItem: string;
  routerLink: string;
  parentTitle: string;
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  showMenu = "";
  showSubMenu = "";
  currentUser: UserLoginResponse;
  searchTerm = "";
  filteredResults: SearchResult[] = [];

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = "0";
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = "0";
    } else {
      this.showSubMenu = element;
    }
  }

  // Search functionality
  onSearchChange() {
    if (this.searchTerm.trim() === "") {
      this.filteredResults = [];
      return;
    }

    this.filteredResults = this.searchInMenu(this.searchTerm.toLowerCase());
  }

  searchInMenu(searchTerm: string): SearchResult[] {
    const results: SearchResult[] = [];

    if (!this.currentUser?.menuList) return results;

    this.currentUser.menuList.forEach((category: MenuItemWithSubDto) => {
      if (category.items && category.items.length > 0) {
        category.items.forEach((subItem: MenuItemWithSubDto) => {
          // Alt menü öğesinde arama - hem translateKey hem de tercüme metninde
          const subItemTranslated = this.translate.instant(subItem.translateKey || '');
          if (subItem.translateKey?.toLowerCase().includes(searchTerm) ||
            subItem.routerLink?.toLowerCase().includes(searchTerm) ||
            subItemTranslated.toLowerCase().includes(searchTerm)) {
            results.push({
              category: this.translate.instant(category.translateKey || ''),
              menuItem: subItemTranslated,
              routerLink: subItem.routerLink || '',
              parentTitle: category.title || ''
            });
          }

          // Üçüncü seviye menüde arama
          if (subItem.items && subItem.items.length > 0) {
            subItem.items.forEach((subSubItem: MenuItemWithSubDto) => {
              const subSubItemTranslated = this.translate.instant(subSubItem.translateKey || '');
              if (subSubItem.translateKey?.toLowerCase().includes(searchTerm) ||
                subSubItem.routerLink?.toLowerCase().includes(searchTerm) ||
                subSubItemTranslated.toLowerCase().includes(searchTerm)) {
                results.push({
                  category: this.translate.instant(category.translateKey || ''),
                  menuItem: subSubItemTranslated,
                  routerLink: subSubItem.routerLink || '',
                  parentTitle: category.title || ''
                });
              }
            });
          }
        });
      }
    });

    return results.slice(0, 10); // Maksimum 10 sonuç
  }

  navigateToMenuItem(result: SearchResult) {
    // İlgili kategoriyi aç
    this.showMenu = result.parentTitle;

    // Search'i temizle
    this.clearSearch();

    // Sayfaya git
    this.router.navigate([result.routerLink]);
  }

  clearSearch() {
    this.searchTerm = "";
    this.filteredResults = [];
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.authService.currentUser.subscribe((res) => {
      this.currentUser = res;
      this.authService.getRoleCodes();
    });
  }

  // End open close
  ngOnInit() {
  }

  logout() {
    this.authService.doLogout();
  }
}
